<template>
  <component is="style" v-if="field==='physio'">
    :root {
    --current:var(--green);
    --current-background: var(--green-background);
    }
  </component>
  <component is="style" v-else-if="field==='logo'">
    :root {
    --current:var(--light-blue);
    --current-background: var(--light-blue-background);
    }
  </component>
  <component is="style" v-else-if="field==='ergo'">
    :root {
    --current:var(--lila);
    --current-background: var(--lila-background);
    }
  </component>
  <component is="style" v-else-if="field==='fit'">
    :root {
    --current:var(--pink);
    --current-background: var(--pink-background);
    }
  </component>
  <component is="style" v-else>
    :root {
    --current:var(--dark-blue);
    --current-background: var(--blue-background);
    }
  </component>

  <div class="static-content-wrapper">
    <div class="content-line content-line-career" v-if="field!==null&&position!==null">
      <div class="content-line-inner">
        <h1>{{ position.Titel }}</h1>
        <div class="career-folding-wrapper">
          <template v-if="Array.isArray(position.Inhalt)" v-for="(area, key) in position.Inhalt">
            <div class="career-foldable-entry">
              <div :class="'career-foldable-entry-heading '+(states[key]?'open':'')"
                   @click="openFold(key)">
                {{ area.name }}
                <span class="career-foldable-icon" v-html="getIcon('arrow-down-s')" />
              </div>
              <div class="career-foldable-entry-content" ref="foldArea">
                <div class="career-foldable-entry-content-inner" v-html="area.value" />
              </div>
            </div>
          </template>
        </div>
        <div class="standort-detail-wrapper angebot-detail-wrapper fast-apply-benefits career-benefits"
             ref="benefitsContainer" v-if="showBenefitsState">
          <div class="standort-detail" id="benefits">
            <h1>Dein Plus bei <span class="medau">Medau</span></h1>
            <div v-html="benefitsContent" />
          </div>
        </div>
        <div :class="'fast-apply-benefits-button '+(showBenefitsState?'turned':'')" @click="showBenefits()">
          <img :src="getImage('plus.svg')" alt="">
        </div>
        <div class="career-buttons">
          <div class="career-button" @click="openFastApply()">Schnellbewerbung</div>
          <div class="career-button" @click="openOldSchool()">Alte Schule</div>
          <a class="career-button"
             :href="this.config.imageBaseUrl+position.PDF.data.attributes.url"
             v-if="position.PDF.data!==null"
             target="_blank"
          >PDF</a>
        </div>
      </div>
    </div>
    <div class="content-line content-line-career" v-else>
      <div class="content-line-inner">
        <LoadingSpinner class="career-loading-spinner" />
        <p>Daten werden geladen</p>
      </div>
    </div>
    <div class="content-line-foldable" ref="second">
      <div class="content-line career-position">
        <div class="content-line-inner" v-if="secondType==='fastApply'">
          <h1 class="career">Schnellbewerbung für die Stelle:</h1>
          <h3>{{ position.title }}</h3>
          <form class="fast-apply" @submit.prevent="submitApplication()">
            <input type="text" name="first_name" id="first_name"
                   placeholder="Vorname*">
            <span class="form-error-apply" v-if="applicationFormErrorFirstName">
                                    Bitte geben Sie Ihren Vornamen an!</span>
            <input type="text" name="last_name" id="last_name"
                   placeholder="Nachname*">
            <span class="form-error-apply" v-if="applicationFormErrorLastName">
                                    Bitte geben Sie Ihren Nachnamen an!</span>
            <input type="text" name="mail" id="mail"
                   placeholder="E-Mail-Adresse*">
            <span class="form-error-apply" v-if="applicationFormErrorMail">
                                    Bitte geben Sie Ihre E-Mail-Adresse an!</span>
            <input type="text" name="phone" id="phone"
                   placeholder="Telefon">
            <label for="docs" id="docs-label" v-if="files.length===0">
              Bewerbungsdokumente (falls vorliegend)
            </label>
            <label for="docs" id="docs-label" v-else>
                            <span>
                                {{ files.join(", ") }}
                            </span>
            </label>
            <input type="file" multiple="multiple" name="docs" id="docs" @change="fileChange()"
                   placeholder="Bewerbungsdokumente (falls vorliegend)">
            <label class="privacy-wrapper">
              <input type="checkbox" name="privacy" id="privacy" value="ok">
              <span>
                                Ja, ich bin einverstanden, dass meine personenbezogenen Daten elektronisch erhoben und
                                gespeichert werden. Meine Daten werden nur zum Zweck der Beantwortung und Bearbeitung
                                meiner Bewerbung verwendet. Die
                                <router-link to="/seiten/datenschutz">Datenschutzhinweise</router-link>
                                habe ich zur Kenntnis genommen.*
                            </span>
            </label>
            <div class="form-error-apply" v-if="applicationFormErrorPrivacy">
              Bitte stimmen Sie der Datenverarbeitung zu!
            </div>
            <button class="fast-apply-button">Abschicken</button>
            <div class="application-messages">
              <div v-if="applicationSuccess" class="application-success">
                Bewerbung erfolgreich übertragen!
              </div>
              <div v-if="applicationDuplicate" class="application-error">
                Sie haben sich bereits mit dieser E-Mail-Adresse auf diese Stelle beworben.
              </div>
              <div v-if="applicationFailure" class="application-error">
                Fehler! Die Bewerbung konnte nicht übertragen werden. Bitte versuchen Sie es erneut.
                Falls der Fehler bestehen bleibt, übermitteln Sie Ihre Bewerbung bitte per "Alte
                Schule".
              </div>
              <div v-if="applicationLoading" class="application-loading mail-success">
                <LoadingSpinner />
              </div>
            </div>
          </form>
        </div>
        <div class="content-line-inner" v-if="secondType==='oldSchool'">
          <h1 class="career">Kontaktdaten für die Stelle:</h1>
          <h3>{{ position.title }}</h3>
          <div class="career-old-school-text" v-if="oldSchoolData" v-html="oldSchoolData" />
          <div class="career-old-school-text" v-else>
            <p>Medau-Therapy-Services GmbH</p>
            <p>Frau Astrid Braun</p>
            <p>Schloss Hohenfels 1</p>
            <p>96450 Coburg</p>
            <p><br /></p>
            <p>karriere@medau-ts.de</p>
          </div>
        </div>
      </div>
    </div>
    <MedauFooter />
  </div>
</template>

<script>
import MedauFooter from "@/components/static/MedauFooter.vue";
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";
import LoadingAnimation from "@/components/elements/LoadingAnimation.vue";
import {nextTick} from "vue";

export default {
    data() {
        return {
            positionId: this.$route.params.position,
            field: null,
            position: null,
            states: [],
            timeouts: [],
            secondType: null,
            autoTimeout: null,
            secondState: false,
            oldSchoolData: null,
            autoTimeoutBenefits: null,
            showBenefitsState: false,
            benefits: null,
            applicationFormErrorPrivacy: false,
            applicationFormErrorFirstName: false,
            applicationFormErrorLastName: false,
            applicationFormErrorMail: false,
            applicationSuccess: false,
            applicationFailure: false,
            applicationDuplicate: false,
            applicationLoading: false,
            files: [],
        }
    },
    components: {
        LoadingAnimation,
        LoadingSpinner,
        MedauFooter
    },
    computed: {
        benefitsContent() {
            if(this.benefits === null) {
                return 'Benefits werden geladen...';
            }
            if(this.benefits === false) {
                return 'Fehler beim Laden der Benefits...';
            }
            return this.benefits.replace(/medau/ig, '<span class="medau">MEDAU</span>');
        },
    },
    watch: {
        states(val, oldVal) {
            let key;
            for(key of val.keys()) {
                if(val[key] !== oldVal[key]) {
                    break;
                }
            }
            if(oldVal[key] === undefined) {
                return;
            }
            const container = this.$refs.foldArea[key];
            if(this.states[key]) {
                if(this.timeouts[key] !== null) {
                    clearTimeout(this.timeouts[key]);
                    this.timeouts[key] = null;
                }
                if(container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.timeouts[key] = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            } else {
                if(this.timeouts[key] !== null) {
                    clearTimeout(this.timeouts[key]);
                    this.timeouts[key] = null;
                }
                if(!container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.remove("open");
                container.style.height = height;
                setTimeout(() => {
                    container.style.height = '0px';
                }, 0);
            }
        },
        secondState(ignored_val, ignored_oldVal) {
            const container = this.$refs.second;
            if(this.secondState) {
                if(this.autoTimeout !== null) {
                    clearTimeout(this.autoTimeout);
                    this.autoTimeout = null;
                }
                if(container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.autoTimeout = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            } else {
                if(this.autoTimeout !== null) {
                    clearTimeout(this.autoTimeout);
                    this.autoTimeout = null;
                }
                if(!container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.remove("open");
                container.style.height = height;
                setTimeout(() => {
                    container.style.height = '0px';
                }, 0);
            }
        },
        async showBenefitsState(ignored_val, ignored_oldVal) {
            if(this.showBenefitsState) {
                await nextTick();
                const container = this.$refs.benefitsContainer;
                if(this.autoTimeoutBenefits !== null) {
                    clearTimeout(this.autoTimeoutBenefits);
                    this.autoTimeoutBenefits = null;
                }
                if(container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.autoTimeoutBenefits = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            }
        },
    },
    methods: {
        openFold(key) {
            const states = [...this.states];
            states[key] = !states[key]
            this.states = states;
        },
        async openFastApply() {
            if(this.secondType !== 'fastApply') {
                this.secondType = 'fastApply';
                await nextTick();
                this.secondState = true;
            } else {
                this.secondState = !this.secondState;
            }
        },
        async openOldSchool() {
            if(this.secondType !== 'oldSchool') {
                this.secondType = 'oldSchool';
                await nextTick();
                this.secondState = true;
            } else {
                this.secondState = !this.secondState;
            }
        },
        loadOldSchool() {
            this.apiRequest('/karriere-old-school')
                .then(cnt => {
                    this.oldSchoolData = cnt?.data?.attributes?.Inhalt;
                })
                .catch(() => this.oldSchoolData = false);
        },
        loadPosition() {
            this.apiRequest('/positions/' + this.positionId + '?populate=deep')
                .then(cnt => {
                    this.position = cnt?.data?.attributes;

                    this.handleSEOObject(cnt.data?.attributes?.seo || null);
                    this.states = [];
                    this.timeouts = [];
                    for(let i = 0; i < this.position.Inhalt.length; i++) {
                        this.states.push(false);
                        this.timeouts.push(null);
                    }
                    if(this.position.Bereich !== null) {
                        this.field = this.position.Bereich?.toLowerCase();
                    } else {
                        this.field = "generic";
                    }
                })
                .catch(() => this.position = false);
        },
        closeBenefits() {
            const container = this.$refs.benefitsContainer;
            if(this.autoTimeoutBenefits !== null) {
                clearTimeout(this.autoTimeoutBenefits);
                this.autoTimeoutBenefits = null;
            }
            if(!container.classList.contains("open")) {
                return;
            }
            container.style.height = "auto";
            const height = container.clientHeight + "px";
            container.classList.remove("open");
            container.style.height = height;
            setTimeout(() => {
                container.style.height = '0px';
            }, 0);
            setTimeout(() => {
                this.showBenefitsState = false;
            }, 500);
        },
        showBenefits() {
            if(this.showBenefitsState) {
                this.closeBenefits();
            } else {
                this.showBenefitsState = true;
                nextTick().then(() => {
                    document.getElementById("benefits").scrollIntoView({behavior: "smooth"});
                });
            }
        },
        loadBenefits() {
            this.apiRequest('/karriere-benefits')
                .then(cnt => {
                    this.benefits = cnt.data.attributes.Inhalt;
                })
                .catch(() => this.benefits = false);
        },
        fileRead(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function(e) {
                    const dataURL = e.target.result;
                    const parts = dataURL.split(',');
                    if(parts.length < 2) {
                        resolve();
                    }
                    resolve(parts[1]);
                };
                reader.readAsDataURL(file);
            });
        },
        async submitApplication() {
            const id = this.positionId;
            const firstName = document.getElementById("first_name").value;
            const lastName = document.getElementById("last_name").value;
            const mail = document.getElementById("mail").value;
            const phone = document.getElementById("phone").value;
            const files = document.getElementById("docs").files;
            const privacy = document.getElementById("privacy").checked;

            this.applicationFormErrorPrivacy = !privacy;
            this.applicationFormErrorFirstName = firstName === "";
            this.applicationFormErrorLastName = lastName === "";
            this.applicationFormErrorMail = mail === "";
            if(!privacy || firstName === "" || lastName === "" || mail === "") {
                return;
            }

            const finalFiles = [];
            for(const file of files) {
                finalFiles.push({
                    base64: await this.fileRead(file),
                    name: file.name,
                    type: file.type,
                });
            }

            this.applicationSuccess = false;
            this.applicationFailure = false;
            this.applicationDuplicate = false;
            this.applicationLoading = true;

            this.apiRequest('/career', 'post', {
                id: id,
                firstName: firstName,
                lastName: lastName,
                mail: mail,
                phone: phone,
                files: finalFiles,
            }).then(cnt => {
                this.applicationLoading = false;
                if(cnt.error === false) {
                    this.applicationSuccess = true;
                    this.applicationFailure = false;
                    this.applicationDuplicate = false;

                    document.getElementById("first_name").value = "";
                    document.getElementById("last_name").value = "";
                    document.getElementById("mail").value = "";
                    document.getElementById("phone").value = "";
                    this.files = [];
                    document.getElementById("docs").value = null;
                    document.getElementById("privacy").checked = false;
                } else {
                    this.applicationSuccess = false;
                    if(cnt.type === 'alreadyExists') {
                        this.applicationFailure = false;
                        this.applicationDuplicate = true;
                    } else {
                        this.applicationFailure = true;
                        this.applicationDuplicate = false;
                    }
                }
                console.log(cnt);
            });
        },
        fileChange() {
            const files = document.getElementById("docs").files;
            const fileNames = [];
            for(const file of files) {
                fileNames.push(file.name);
            }
            this.files = fileNames;
        }
    },
    mounted() {
        this.$store.commit("setPageTitle", "Karriere");
        document.body.classList.add("clicked");

        this.loadOldSchool();
        this.loadPosition();
        this.loadBenefits();
    },
}
</script>